import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import tools from './Tools'
// MUI
import {
    Grid,
    Typography,
    IconButton,
    Container,
    Tooltip,
} from "@mui/material"

export default function Tooling() {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <Container
            maxWidth="md"
            sx={{ my: { xs: "15vh", xl: "20vh" } }}
            id="tooling">
            <Typography
                variant="h2"
                component={motion.h2}
                sx={{
                    pb: 15
                }}
                align="center"
                color="primary"
                initial={{ opacity: 0 }}
                transition={{ delay: 0.5, duration: 1 }}
                animate={isInView ? { opacity: 1 } : "none"}
            >
                Tooling
            </Typography>
            <Grid container
                component={motion.div}
                spacing={{
                    xs: 2,
                    sm: 3,
                    md: 6,
                    lg: 12
                }}
                sx={{ my: 3 }}
                ref={ref} >
                {tools.map((tool, index) => {
                    return (
                        <Grid item
                            key={tool.id}
                            xs={4}
                            sx={{ textAlign: "center" }}>
                            <Tooltip title={tool.title}>
                                <IconButton
                                    component={motion.a}
                                    whileHover={{ color: tool.color, transition: { delay: 0 } }}
                                    href={tool.href}
                                    initial={{ opacity: 0, y: "4em" }}
                                    animate={isInView ? { opacity: 1, y: 0 } : "none"}
                                    transition={{ delay: index * 0.1 }}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    color="secondary" >
                                    {tool.icon}
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    )
                })}

            </Grid>
        </Container >
    )
}